import axios, { CreateAxiosDefaults } from "axios";
import https from "https";

export const getApiUrl = () => {
  return (process.env.GATSBY_API_URL ?? "") + process.env.GATSBY_API_PATH;
};

export const getConsentsApiUrl = () => {
  return (process.env.GATSBY_API_CONSENTS_URL ?? "") + process.env.GATSBY_API_CONSENTS_PATH;
};

export const getApiClient = <T>(additionalConfigs: CreateAxiosDefaults<T> = {}) => {
  const clientDefaults: CreateAxiosDefaults = {
    baseURL: getApiUrl(),
    withCredentials: true,
    ...additionalConfigs,
  };

  return createClient(clientDefaults);
};

const createClient = <T>(additionalConfigs: CreateAxiosDefaults<T> = {}) => {
  if (process.env.GATSBY_UNAUTHORIZED_HTTP_REQUEST === "allow") {
    additionalConfigs.httpsAgent = new https.Agent({
      rejectUnauthorized: false,
      requestCert: true,
    });
  }

  return axios.create(additionalConfigs);
};

export const getConsentsApiClient = <T>(additionalConfigs: CreateAxiosDefaults<T> = {}) => {
  const clientDefaults: CreateAxiosDefaults = {
    baseURL: getConsentsApiUrl(),
    ...additionalConfigs,
  };

  return createClient(clientDefaults);
};
